<template>
  <form method="POST" action @submit.prevent="addBulletin">
    <div class="card">
      <div v-if="!saving" class="card-body px-3">
        <div class="card-title h5">
          <strong>New Bulletin</strong>
        </div>
        <div class="card-body">
          <div class="form-group row">
            <label for="bulletin_text" class="col-form-label mx-2">Text:</label>
            <textarea
              :class="['form-control', 'mx-2', errors.text ? 'is-invalid' : '']"
              id="bulletin_text"
              name="bulletin_text"
              v-model="newBulletin.text"
            ></textarea>
            <span v-if="errors.text" class="invalid-feedback mx-2">
              <strong>{{ errors.text[0] }}</strong>
            </span>
          </div>

          <div class="form-group row">
            <label for="dismissable" class="col-sm-4 col-form-label text-md-right">Dismissable</label>
            <div class="col-md-6">
              <div class="form-check">
                <label>
                  <input
                    id="dismissable"
                    type="checkbox"
                    class="form-check-input"
                    name="dismissable"
                    v-model="newBulletin.dismissable"
                  />
                </label>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label text-md-right">Expiry Date</label>
            <div class="col-md-6">
              <input
                id="expiry_date"
                type="date"
                :class="['form-control', errors.expiry_time ? 'is-invalid' : '']"
                name="expiry_date"
                v-model="newBulletin.expiry_time"
              />
            </div>
            <div class="col-auto offset-sm-4 text-center">
              <small class="text-secondary">Leave blank to never expire</small>
            </div>

            <span v-if="errors.expiry_time" class="invalid-feedback">
              <strong>{{ errors.expiry_time[0] }}</strong>
            </span>
          </div>

          <template v-if="pages.length > 1">
            <div class="form-group row" v-for="page in pages" :key="page.id">
              <label
                :for="'bulletinPage-' + page.id"
                class="col-sm-4 col-form-label text-md-right text-truncate"
              >{{page.name}}</label>

              <div class="col-md-6">
                <div class="form-check">
                  <label>
                    <input
                      :id="'bulletinPage-' + page.id"
                      type="checkbox"
                      class="form-check-input"
                      :value="page.id"
                      v-model="newBulletin.page_ids"
                    />
                  </label>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-else class="card-body">Saving..</div>
      <div class="row justify-content-center mb-3">
        <div v-if="editId" class="col justify-content-center mx-2 mx-sm-0">
          <button
            type="submit"
            class="btn btn-primary px-3 rounded-pill col-sm-4 offset-sm-2 mb-2 mb-sm-0"
            v-bind:class="{ disabled: saving }"
            @click="saveBulletin()"
          >Save Bulletin</button>
          <button
            type="submit"
            class="btn btn-danger px-3 rounded-pill col-sm-4"
            v-bind:class="{ disabled: saving }"
            @click="deleteBulletin()"
          >Delete Bulletin</button>
        </div>
        <div v-else class="col-auto">
          <button
            type="submit"
            class="btn btn-primary px-3 rounded-pill col"
            v-bind:class="{ disabled: saving }"
            @click="addBulletin()"
          >Add Bulletin</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "NewBulletin",

  props: {
    pages: {
      type: Array,
      required: true
    },
    pageId: {
      type: Number,
      required: true
    },
    editId: {
      type: Number,
      required: false,
      default: null
    }
  },

  data() {
    return {
      newBulletin: {
        page_ids: [this.pageId]
      },
      saving: false,
      errors: []
    };
  },

  mounted() {
    if (this.editId)
    {
      this.fetchEditBulletin()
    }
  },

  methods: {
    addBulletin() {
      if (!this.saving) {
        //debounce
        var self = this;
        this.saving = true;
        axios
          .post("/api/bulletins", this.newBulletin)
          .then(function(response) {
            self.saving = false;
            BulletinEventBus.$emit("reload");
            location.reload(); //cheap force reload of page as not everything is vueified yet.
          })
          .catch(function(err) {
            console.log(err);
            self.saving = false;
            self.errors = err.response.data.errors;
          });
      }
    },
    saveBulletin() {
      if (!this.saving) {
        //debounce
        var self = this;
        this.saving = true;
        axios
          .put("/api/bulletins/" + this.editId, this.newBulletin)
          .then(function(response) {
            self.saving = false;
            BulletinEventBus.$emit("reload");
            location.reload(); //cheap force reload of page as not everything is vueified yet.
          })
          .catch(function(err) {
            console.log(err);
            self.saving = false;
            self.errors = err.response.data.errors;
          });
      }
    },
    deleteBulletin() {
      if (!this.saving) {
        //debounce
        var self = this;
        this.saving = true;
        axios
          .delete("/api/bulletins/" + this.editId)
          .then(function(response) {
            self.saving = false;
            BulletinEventBus.$emit("reload");
            location.reload(); //cheap force reload of page as not everything is vueified yet.
          })
          .catch(function(err) {
            console.log(err);
            self.saving = false;
            self.errors = err.response.data.errors;
          });
      }
    },
    fetchEditBulletin() {
        this.saving = true;
        var self = this;
        axios.get('/api/bulletins/' + self.editId)
        .then(function (response) {
            self.saving = false;
            self.newBulletin = response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
    },
  }
};
</script>

<style scoped>
</style>